<template lang="pug">
  .container-listagem
    modal-assinatura(
      v-if="modal"
      @closeModal="closeModal()"
      titulo="Assinar documentos"
      texto="Para realizar a assinatura do(s) documento(s) é necessário informar a senha do seu certificado digital. Ao finalizar, o(s) documento(s) selecionado(s) será(ão) assinado(s)."
      @callbackSucesso="callbackModalAssinatura"
    )

    el-row
      el-col
        Pesquisa(
          placeHolder = "Informe o nome do documento, responsável ou tipo do documento"
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
          :hasPesquisaAvancada="true"
          @searchAdvanced="pesquisarAvancado"
          @changeTipoPesquisa="changePesquisa"
        )
          template(slot="pesquisaAvancada")
            pesquisa-avancada-documentos(
              :filtro="pesquisaAvancada"
            )

    el-card.default-card(shadow="hover")
      el-row.button-cadastro(type="flex")
          el-button(
            @click="cadastrarCert",
            type="success",
            icon="el-icon-plus"
            :style="[showCadastrarCerfificado ? {'display': 'initial'} : {'display': 'none'}]"
          )
            span.center Cadastrar certificado
          el-button(
            @click="cadastrar",
            type="success",
            icon="el-icon-plus"
          )
            span.center Cadastrar documento
      app-divider-refresh-button(
        label="Listagem de Documentos",
        @click="resetPesquisa",
        :hasButton="true"
        content="Atualizar documentos"
      )
      div
        div.selecao
          div#checkbox
            div#title
              span Selecionar documentos:
            div#content
              el-checkbox.selecao(
                v-model="selTodos"
              ) Selecionar todos listados
        div.selecao
          div#checkbox-container
            div#checkbox
              div#title2
                span Exibir Documentos:
              div#content
                el-row.column-checkbox
                  el-checkbox(
                    @change="handleCheckboxSearch($event, 'naoAssinadoPorUsuarioAtual')"
                  )
                    label.titulo Documentos não assinados

                el-row.column-checkbox
                  el-checkbox(
                    @change="handleCheckboxSearch($event, 'assinadoPorUsuarioAtual')"
                  )
                    label.titulo Documentos assinados

      div#divider

      el-table.table(:data="documentosCadastrados", @select="handleSelect", ref="table"  @sort-change='sortChanged')
        template(slot="empty") Não há registros.
        el-table-column(
          type="selection"
          width="55"
          :selectable="isResponsavelEnaoAssinado"
        )
        el-table-column(
          prop='nome'
          label='Nome do documento',
          width="auto"
          sortable="custom"
          :formatter="Utils.formatEmptyRow"
        )
        el-table-column(
          prop='dataEnvio'
          label='Data de envio',
          width="auto"
          sortable="custom"
          :formatter="formatDate"
        )
        el-table-column(
          label='Responsável(eis)',
          :formatter="Utils.formatEmptyRow"
          width="auto"
        )
          template(slot-scope='scope')
            list-responsavel-assinatura(:assinadores="scope.row.assinadores")
        el-table-column(
          prop='tipo.nome'
          label='Documento',
          :formatter="Utils.formatEmptyRow"
          width="auto"
        )
        el-table-column(
          label='Ações',
          width='120'
        )
          template(slot-scope='scope')
            button-acoes(:acoes="botoesAcao(scope.row)")

      app-paginacao(
        :total="totalCadastros"
        :pagina="pagina",
        @changePage="changePage"
      )
      .button-container
        el-button(icon="el-icon-edit", @click="assinarDocumentos()")  Assinar selecionados
</template>

<script>
import AppAnexarArquivo from '@/components/AppAnexarArquivo'
import { mapActions, mapGetters } from 'vuex'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import Pesquisa from '@/components/Pesquisa'
import Utils from '@/utils/utils'
import ModalAssinatura from '@/components/ModalAssinatura'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CONFIGS from '@/constants/configs'
import FileHelper from '@/utils/fileHelper'
import cloneDeep from 'lodash/cloneDeep'
import ListResponsavelAssinatura from '@/screens/assinatura/components/ListResponsavelAssinatura'
import PesquisaAvancadaDocumentos from '@/screens/assinatura/components/PesquisaAvancadaDocumentos'

const FILTRO_EMPTY = {
  pagina: 0,
  tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO,
  assinado: false,
  assinadoPorUsuarioAtual: null,
  naoAssinadoPorUsuarioAtual: null,
  pesquisaSimples: '',
  ativo: true
}

const PESQUISA_AVANCADA_EMPTY = {
  nome: null,
  responsavel: null,
  dataEnvio: null,
  tipoDocumento: null,
  assinadoPorUsuarioAtual: null,
  naoAssinadoPorUsuarioAtual: null,
  ativo: true
}

export default {
  data () {
    return {
      documentosCadastrados: [],
      totalCadastros: 0,
      filtro: cloneDeep(FILTRO_EMPTY),
      pesquisaAvancada: cloneDeep(PESQUISA_AVANCADA_EMPTY),
      Utils,
      documentosSelecionados: [],
      documentosParaAssinatura: [],
      modal: false,
      responsavel: null,
      showCadastrarCerfificado: false,
      selTodos: false,
      assinadoPorUsuarioAtual: null,
      naoAssinadoPorUsuarioAtual: null,
      desmarcaTodos: true,
      key: 0
    }
  },

  components: {
    AppAnexarArquivo,
    ButtonAcoes,
    AppPaginacao,
    AppDividerRefreshButton,
    Pesquisa,
    ModalAssinatura,
    ListResponsavelAssinatura,
    PesquisaAvancadaDocumentos
  },

  mixins: [
    AppNotificacao
  ],

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    pagina () {
      return this.filtro.pagina + 1
    }
  },

  watch: {
    async selTodos () {
      if (this.selTodos) {
        this.documentosSelecionados = await this.findAllAssinaveis(this.filtro)
        this.confereCheckbox()
        this.desmarcaTodos = true
      } else {
        if (this.desmarcaTodos) {
          this.$refs.table.clearSelection()
          this.documentosSelecionados = []
        }
      }
    }
  },

  methods: {
    ...mapActions({
      findDocumentos: 'documentoAssinatura/find',
      setMainCardVisibility: 'userInterface/setMainCardVisibility',
      resetLoader: 'loader/resetLoader',
      setLoader: 'loader/setLoader',
      downloadDocumentos: 'documentoAssinatura/download',
      assinar: 'documentoAssinatura/assinar',
      excluirDocumento: 'documentoAssinatura/excluirDocumento',
      getResponsavel: 'responsavel/getResponsavel',
      findAllAssinaveis: 'documentoAssinatura/findAssinaveis'
    }),

    resetPesquisa () {
      this.pesquisaAvancada = cloneDeep(PESQUISA_AVANCADA_EMPTY)
      this.filtro = cloneDeep(FILTRO_EMPTY)
      this.getDocumentosCadastrados()
    },

    handlePesquisa (value) {
      this.filtro.pesquisaSimples = value
      this.getDocumentosCadastrados()
    },

    async changePage (newPage) {
      this.filtro.pagina = newPage - 1
      await this.getDocumentosCadastrados()
      this.confereCheckbox()
    },

    confereCheckbox () {
      let tabela = this.$refs.table
      let documentos = this.documentosSelecionados
      tabela.tableData.forEach((row) => {
        if (documentos.filter(doc => doc.id === row.id).length > 0) tabela.toggleRowSelection(row, true)
      })
    },

    validarUsuarioAindaPodeAssinar (documento) {
      let result = false
      const idsResponsaveis = this.responsavel.responsaveisAssinatura

      documento.assinadores.forEach(assinador => {
        if (!assinador.assinado && idsResponsaveis.includes(assinador.responsavel.id)) {
          result = true
        }
      })

      return result
    },

    botoesAcao (documento) {
      const acoes = []

      acoes.push({
        click: this.visualizar.bind(this, documento),
        icon: 'visibility',
        title: 'Visualizar documento',
        active: true
      })

      if (!documento.ativo) {
        return acoes
      }

      if (documento.jaAssinadoPorPeloMenosPorUmaPessoa) {
        if (this.validarUsuarioAindaPodeAssinar(documento)) {
          acoes.push({
            click: this.assinarDocumento.bind(this, documento),
            icon: 'edit',
            title: 'Assinar documento',
            active: true
          })
        }

        acoes.push({
          click: this.excluir.bind(this, documento),
          icon: 'delete_forever',
          title: 'Excluir documento',
          active: true
        })
      } else {
        acoes.push({
          click: this.assinarDocumento.bind(this, documento),
          icon: 'edit',
          title: 'Assinar documento',
          active: true
        })

        acoes.push({
          click: this.editar.bind(this, documento),
          icon: 'description',
          title: 'Editar documento',
          active: true
        })

        acoes.push({
          click: this.downloadDocumento.bind(this, documento),
          icon: 'get_app',
          title: 'Download do documento',
          active: true
        })

        acoes.push({
          click: this.excluir.bind(this, documento),
          icon: 'delete_forever',
          title: 'Excluir documento',
          active: true
        })
      }

      return acoes
    },

    closeModal () {
      this.modal = false
    },

    cadastrar (documento) {
      this.$router.push({
        name: 'assinatura/cadastrarDocumento'
      })
    },
    cadastrarCert (documento) {
      this.$router.push({
        name: 'assinatura/cadastrarCertificado'
      })
    },

    async downloadDocumento (documento) {
      const arrayBuffer = await this.downloadDocumentos({ id: documento.id })
      FileHelper.saveFile(arrayBuffer, `${documento.nome}.pdf`)
    },

    editar (documento) {
      this.$router.push({
        name: 'assinatura/cadastrarDocumento',
        query: {
          id: documento.id
        }
      })
    },

    visualizar (documento) {
      this.$router.push({
        name: 'assinatura/visualizarDocumento',
        query: {
          id: documento.id
        }
      })
    },

    excluir (documento) {
      this.confirmBox('Você realmente deseja excluir o documento ' + documento.nome + '?', this.$messages.TITULO_WARNING,
        async () => {
          try {
            await this.excluirDocumento(documento.id)
            this.getDocumentosCadastrados()
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.SUCESSO_EXCLUIR_DOCUMENTO_ASSINATURA
            )
          } catch (error) {
            this.showNotificacao(
              this.$messages.TIPO_WARNING,
              this.$messages.TITULO_WARNING,
              error.message
            )
          }
        },
        () => { }, 'Confirmar', 'Cancelar')
    },

    async callbackModalAssinatura (senha) {
      const ids = this.documentosParaAssinatura.map(documento => documento.id)

      try {
        await this.assinar({
          ids: ids,
          password: senha
        })

        this.closeModal()

        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.DOCUMENTOS_ASSINADOS_SUCESSO
        )
        this.filtro.pagina = 0
        this.getDocumentosCadastrados()
      } catch (error) {
      }
      this.documentosSelecionados = []
    },

    assinarDocumento (documento) {
      this.$router.push({
        name: 'assinatura/assinarDocumeto',
        query: {
          id: documento.id
        }
      })
    },

    assinarDocumentos () {
      if (this.documentosSelecionados.length === 0) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.SELECIONE_UM_DOCUMENTO
        )
      } else {
        this.documentosParaAssinatura = this.documentosSelecionados
        this.modal = true
      }
    },

    isResponsavelEnaoAssinado (row) {
      // Verifica se o usuário é um dos responsáveis e se ainda não assinou o documento
      const assinadores = row.assinadores
      const responsavelAssinatura = assinadores.find(assinador => assinador.responsavel.usuario.id === this.usuario.id)
      if ((responsavelAssinatura && !responsavelAssinatura.assinado)) {
        return true
      }
      return false
    },

    handleSelect (val, row) {
      if (!this.documentosSelecionados.filter(e => e.id === row.id).length > 0) {
        this.documentosSelecionados.push(row)
      } else {
        if (this.selTodos) {
          this.desmarcaTodos = false
          this.selTodos = false
        }
        let index = this.documentosSelecionados.findIndex((doc, i, a) => {
          return doc.id === row.id
        })
        this.documentosSelecionados.splice(index, 1)
      }
    },

    async getDocumentosCadastrados () {
      this.setLoader()
      const result = await this.findDocumentos(this.filtro)
      this.documentosCadastrados = result.documentosAssinatura
      this.totalCadastros = result.total
      this.confereCheckbox()
      this.resetLoader()
    },

    formatDate (row, column, prop) {
      return Utils.formatDate(prop) || '-'
    },

    sortChanged ({ column, prop, order }) {
      if (order !== null) {
        const direcaoMap = {
          'ascending': 'ASC',
          'descending': 'DESC'
        }
        this.filtro.ordem = prop
        this.filtro.ordemDirecao = direcaoMap[order]
      }

      this.getDocumentosCadastrados()
    },
    async pesquisar (pesquisaSimples) {
      this.filtro.pesquisaSimples = pesquisaSimples
      await this.getDocumentosCadastrados()

      this.filtro = cloneDeep(FILTRO_EMPTY)
    },
    async pesquisarAvancado () {
      this.setFiltroAdvancedSearch()
      await this.pesquisar()
    },
    setFiltroAdvancedSearch (pesquisaSimples) {
      this.filtro.nome = pesquisaSimples || this.pesquisaAvancada.nome

      if (this.pesquisaAvancada.responsavel) {
        this.filtro.responsavel = this.pesquisaAvancada.responsavel.usuario.pessoa.nomeRazaoSocial
      }

      if (this.pesquisaAvancada.dataEnvio) {
        this.filtro.dataEnvioInicio = this.pesquisaAvancada.dataEnvio[0]
        this.filtro.dataEnvioFim = this.pesquisaAvancada.dataEnvio[1]
      }

      if (this.pesquisaAvancada.tipoDocumento) {
        this.filtro.tipoDocumento = this.pesquisaAvancada.tipoDocumento
      }
      this.filtro.ativo = this.pesquisaAvancada.ativo
      this.filtro.simplificado = false
    },

    handleCheckboxSearch (value, checkbox) {
      this[checkbox] = value
      this.filtro[checkbox] = value

      if (!this.assinadoPorUsuarioAtual && !this.naoAssinadoPorUsuarioAtual) {
        this.filtro.assinadoPorUsuarioAtual = null
        this.filtro.naoAssinadoPorUsuarioAtual = null
      }

      this.handlePesquisa('')
    },

    changePesquisa (val) {
      this.filtro = cloneDeep(FILTRO_EMPTY)
      this.filtro.simplificado = val
      this.getDocumentosCadastrados()
    }
  },

  created () {
    this.setMainCardVisibility(false)
    this.getDocumentosCadastrados()
    this.documentosSelecionados = []
    if ((process.env.NODE_ENV === 'development' || process.env.NODE_ENV.split('_')[0] === 'testing')) {
      this.showCadastrarCerfificado = true
    }
    this.getResponsavel().then(response => {
      this.responsavel = response
    })
  }
}

</script>

<style lang="scss" scoped>
.button-container {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 40px;
}

.selecao {
  display: inline-block;
  margin-left: 15px;
  margin-top: 8px;
}
.selecao-tit1::after{
  display: inline-block;
  margin-left: 15px;
}

>>> thead .el-checkbox__input {
  display: none;
}

.button-cadastro {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

#checkbox-container {
  display: flex;
  justify-content: space-between;
  padding: 2% 80%;
  display: inline-block;
}

#checkbox {
  display: flex;
  align-items: center;

  #title {
    color: black;
    padding-top: 10px;
  }
  #title2 {
    color: black;
  }

  #content {
    display: flex;
    flex-direction: column;
    align-items: end;
    margin-left: 7px;
    margin-top: 2px;
  }

  .el-checkbox {
    width: 28vh;
  }
}

#divider {
  height: 0.3vh;
  background-color: #d9d9d9;
  margin-top: 1vh;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/ListagemDocumentos.vue